/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Phoenix | v1
 * OpenAPI spec version: 1.0.0
 */

export type WebFilterPlacementKind = typeof WebFilterPlacementKind[keyof typeof WebFilterPlacementKind];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WebFilterPlacementKind = {
  MenuBanner: 'MenuBanner',
  MenuTile: 'MenuTile',
  MenuSpecial: 'MenuSpecial',
  MenuLink: 'MenuLink',
  SearchSpecialPeriods: 'SearchSpecialPeriods',
  SearchTourTypes: 'SearchTourTypes',
  HomeFindTour: 'HomeFindTour',
} as const;
